export const tableFields = [
    ['Descricao', 12],
    ['Qtd. Sabores', 4],
    ['Qtd. Pedaços', 4],
    ['Status', 3],
    ['', 1],
];